package br.com.htms.inspeccaocampo.data

import br.com.htms.inspeccaocampo.auth.AuthApi

data class PessoaEvidencia(
    val id: String,
    val nome: String,
    val matricula: String = "",
    val cargo: String = "",
    val ccCodigo: String = "",
    val ccRotulo: String = ""
)

data class EvidenciaTreinamento(
    val id: String,
    val obra: String,
    val tstNome: String,
    val curso: String,
    val realizadoEm: String,
    val cargaHoras: Double,
    val presentes: Int,
    val homemHora: Double,
    val fotos: Int
)

data class ApoioEvidencia(
    val tsts: List<PessoaEvidencia>,
    val funcionarios: List<PessoaEvidencia>
)

object EvidenciaTreinamentoApi {
    suspend fun apoio(): Result<ApoioEvidencia> =
        AuthApi.apiJson("GET", "/evidencias-treinamento/apoio").mapCatching { text ->
            val o = JsonMap.parse(text)
            ApoioEvidencia(
                tsts = o.array("tsts").orEmpty().mapNotNull { (it as? JsonMap)?.let { u ->
                    val id = u.str("username")
                    if (id.isBlank()) null else PessoaEvidencia(id, u.str("nome").ifBlank { id })
                } },
                funcionarios = o.array("funcionarios").orEmpty().mapNotNull { (it as? JsonMap)?.let { f ->
                    val id = f.str("id")
                    if (id.isBlank()) null else PessoaEvidencia(
                        id, f.str("nome"), f.str("matricula"), f.str("cargo"), f.str("ccCodigo"), f.str("ccRotulo")
                    )
                } }
            )
        }

    suspend fun listar(): Result<List<EvidenciaTreinamento>> =
        AuthApi.apiJson("GET", "/evidencias-treinamento").mapCatching { text ->
            JsonMap.parse(text).array("itens").orEmpty().mapNotNull { (it as? JsonMap)?.let(::itemDe) }
        }

    suspend fun criar(
        obra: String,
        tstUsername: String,
        curso: String,
        realizadoEm: String,
        cargaHoras: Double,
        presentes: Set<String>
    ): Result<Pair<String, Double>> =
        AuthApi.apiJson("POST", "/evidencias-treinamento", corpo(obra, tstUsername, curso, realizadoEm, cargaHoras, presentes))
            .mapCatching { text ->
                val o = JsonMap.parse(text)
                val id = o.obj("item")?.str("id").orEmpty()
                if (id.isBlank()) error(o.str("error").ifBlank { "Resposta inválida" })
                id to (o.double("remHomemHora") ?: 0.0)
            }

    suspend fun foto(id: String, bytes: ByteArray): Result<Unit> =
        AuthApi.apiUploadBytes("/evidencias-treinamento/$id/fotos", bytes, "image/jpeg").map { }

    suspend fun avisar(id: String): Result<Boolean> =
        AuthApi.apiJson("POST", "/evidencias-treinamento/$id/email").map { it.contains("\"enviado\":true") }

    private fun itemDe(o: JsonMap) = EvidenciaTreinamento(
        id = o.str("id"),
        obra = o.str("obra"),
        tstNome = o.str("tstNome"),
        curso = o.str("curso"),
        realizadoEm = o.str("realizadoEm"),
        cargaHoras = o.double("cargaHoras") ?: 0.0,
        presentes = o.array("presentes")?.size ?: 0,
        homemHora = o.double("homemHora") ?: 0.0,
        fotos = o.array("fotos")?.size ?: 0
    )

    private fun corpo(
        obra: String,
        tst: String,
        curso: String,
        data: String,
        carga: Double,
        presentes: Set<String>
    ): String = buildString {
        fun j(s: String) = buildString {
            append('"')
            for (c in s) when (c) {
                '\\' -> append("\\\\")
                '"' -> append("\\\"")
                else -> append(c)
            }
            append('"')
        }
        append("{\"obra\":").append(j(obra))
        append(",\"tstUsername\":").append(j(tst))
        append(",\"curso\":").append(j(curso))
        append(",\"realizadoEm\":").append(j(data))
        append(",\"cargaHoras\":").append(carga)
        append(",\"presentes\":[")
        presentes.forEachIndexed { i, id ->
            if (i > 0) append(',')
            append("{\"id\":").append(j(id)).append('}')
        }
        append("]}")
    }
}
